import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Corporatecabserviceinmumbai() {



  const cardData = {
    keyword: " Corporate Cab Services in Mumbai ",


"headingDescription": "Royal Route Cab offers professional and reliable corporate cab services in Mumbai, designed to meet the transportation needs of businesses, employees, and corporate clients. Whether it is daily office pickups and drops, airport transfers, client meetings, or executive travel, our service ensures punctuality, comfort, and a smooth travel experience. We provide well-maintained vehicles, experienced chauffeurs, GPS-enabled tracking, and transparent billing with no hidden charges. Our flexible plans include hourly rentals, daily commute solutions, and monthly corporate tie-ups tailored for companies of all sizes. With 24/7 support and easy booking options, Royal Route Cab is a trusted partner for corporate travel in Mumbai.",

"topPlaces": [
 
  {
    "title": "Shirdi",
    "description": "Shirdi is one of India's most visited pilgrimage destinations, attracting millions of devotees to the Shri Sai Baba Temple every year. It is a preferred spiritual trip from Mumbai."
  },
  {
    "title": "Nashik",
    "description": "Nashik is famous for its vineyards, religious temples, and the sacred Godavari River. It is a popular destination for wine tourism, pilgrimages, and weekend road trips from Mumbai."
  },
  {
    "title": "Goa",
    "description": "Goa is a favorite holiday destination from Mumbai, offering beautiful beaches, Portuguese architecture, vibrant nightlife, water sports, and delicious seafood."
  },
   {
    "title": "Pune",
    "description": "Pune is one of the most popular outstation destinations from Mumbai, known for its historical landmarks, IT hubs, educational institutions, and pleasant weather. It is ideal for business trips, family travel, and weekend getaways."
  },
  {
    "title": "Lonavala",
    "description": "Lonavala is a scenic hill station located between Mumbai and Pune, famous for its waterfalls, lush green valleys, Tiger Point, and Bhushi Dam. It is a favorite weekend getaway for nature lovers."
  },
  {
    "title": "Mahabaleshwar",
    "description": "Mahabaleshwar is a beautiful hill station known for its strawberry farms, breathtaking viewpoints, cool climate, and attractions like Venna Lake and Arthur's Seat. It is a popular destination for family vacations and honeymoon trips."
  },
  {
    "title": "Aurangabad",
    "description": "Aurangabad is renowned for the UNESCO World Heritage Sites of Ajanta and Ellora Caves, along with Bibi Ka Maqbara. It is a popular historical and cultural destination."
  },
  {
    "title": "Kolhapur",
    "description": "Kolhapur is known for the Mahalakshmi Temple, traditional cuisine, historical forts, and cultural heritage. It is a popular religious and leisure travel destination."
  },
  {
    "title": "Matheran",
    "description": "Matheran is Asia's only automobile-free hill station, offering peaceful surroundings, panoramic viewpoints, toy train rides, and pleasant weather throughout the year."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug is a coastal town famous for its clean beaches, sea forts, water sports, and relaxing atmosphere, making it one of the most popular weekend destinations near Mumbai."
  }
],






services: [
  {
    name: "Corporate Cab Services Mumbai",
    description: "Corporate cab services Mumbai provide professional transportation solutions for businesses of all sizes. This service includes employee pickup and drop, client visits, and corporate travel needs. Well-maintained vehicles and trained drivers ensure punctuality and safety. Flexible packages are available for daily and long-term use. It guarantees reliable and efficient corporate mobility."
  },
  {
    name: "Corporate Taxi Service Mumbai",
    description: "Corporate taxi service Mumbai offers dedicated travel solutions for office staff and executives. This service ensures timely pickups, comfortable rides, and professional conduct. Ideal for meetings, airport transfers, and daily commuting. It ensures smooth and hassle-free corporate travel."
  },
  {
    name: "Business Cab Service Mumbai",
    description: "Business cab service Mumbai provides reliable transportation for business professionals and corporate teams. This service is ideal for meetings, conferences, and office travel. Vehicles are clean and driven by experienced chauffeurs. It ensures punctual and comfortable travel."
  },
  {
    name: "Employee Transportation Mumbai",
    description: "Employee transportation Mumbai offers organized pickup and drop services for company staff. This service ensures safe and timely commuting for employees. Suitable for IT companies, offices, and industries. Flexible scheduling and route planning enhance efficiency. It ensures smooth workforce mobility."
  },
  {
    name: "Office Cab Service Mumbai",
    description: "Office cab service Mumbai provides convenient daily travel solutions for employees. This service includes fixed routes, shift-based pickups, and reliable drop services. Professional drivers ensure safety and punctuality. It ensures stress-free office commuting."
  },
  {
    name: "Company Cab Rental Mumbai",
    description: "Company cab rental Mumbai offers flexible vehicle rental solutions for corporate needs. Businesses can hire cars on daily, weekly, or monthly basis. This service is ideal for employee transport and executive travel. Transparent pricing and reliable service ensure convenience."
  },
  {
    name: "Corporate Car Rental Mumbai",
    description: "Corporate car rental Mumbai provides a wide range of vehicles for business travel. This service includes sedans, SUVs, and premium cars for executives and teams. Flexible rental options make it suitable for various corporate requirements. It ensures comfortable and professional travel."
  },
  {
    name: "Monthly Cab Service Mumbai",
    description: "Monthly cab service Mumbai offers long-term transportation solutions for companies and employees. This service is cost-effective and ideal for regular office travel. Fixed pricing and dedicated vehicles ensure convenience. It ensures reliable and consistent service."
  },
  {
    name: "Corporate Travel Cab Mumbai",
    description: "Corporate travel cab Mumbai provides efficient transportation for business trips, meetings, and events. This service is designed for comfort, punctuality, and professionalism. Suitable for executives and corporate teams. It ensures smooth travel planning."
  },
  {
    name: "Staff Pickup Drop Cab Mumbai",
    description: "Staff pickup drop cab Mumbai offers organized transport for employees with fixed routes and timings. This service ensures safe commuting for staff members. Ideal for companies with multiple shifts. Professional drivers ensure reliability. It guarantees efficient transport management."
  },
  {
    name: "Executive Cab Service Mumbai",
    description: "Executive cab service Mumbai provides premium travel solutions for business leaders and VIP clients. This service includes luxury vehicles and professional chauffeurs. Comfortable interiors and punctual service enhance the experience. It ensures a high-class travel experience."
  },
  {
    name: "Corporate Taxi Booking Mumbai",
    description: "Corporate taxi booking Mumbai allows businesses to easily book cabs for employees and clients. This service offers flexible scheduling and instant confirmations. Suitable for meetings, airport transfers, and office travel. It ensures a hassle-free booking experience."
  },
  {
    name: "Premium Corporate Cab Mumbai",
    description: "Premium corporate cab Mumbai offers high-end vehicles for executive and VIP travel. This service ensures comfort, style, and professionalism. Ideal for corporate events and business meetings. Well-maintained vehicles and trained drivers enhance the experience."
  },
  {
    name: "Reliable Corporate Cab Service Mumbai",
    description: "Reliable corporate cab service Mumbai ensures consistent and dependable travel for companies. This service focuses on punctuality, safety, and customer satisfaction. Suitable for daily office travel and corporate needs. It guarantees a smooth experience."
  },
  {
    name: "Best Corporate Taxi Service Mumbai",
    description: "Best corporate taxi service Mumbai offers top-quality transportation with professional drivers and well-maintained vehicles. This service ensures efficient travel for employees and executives. Multiple vehicle options are available. It guarantees a premium and reliable journey."
  },
  {
    name: "Professional Cab Services Mumbai",
    description: "Professional cab services Mumbai deliver high-standard transportation with trained chauffeurs and quality vehicles. This service is suitable for corporate clients and daily commuters. Focus on punctuality and service quality ensures satisfaction. It guarantees a smooth and comfortable experience."
  }
],

tableData: [
  ["Corporate Cab Services Mumbai", "Corporate Taxi Service Mumbai"],
  ["Business Cab Service Mumbai", "Employee Transportation Mumbai"],
  ["Office Cab Service Mumbai", "Company Cab Rental Mumbai"],
  ["Corporate Car Rental Mumbai", "Monthly Cab Service Mumbai"],
  ["Corporate Travel Cab Mumbai", "Staff Pickup Drop Cab Mumbai"],
  ["Executive Cab Service Mumbai", "Corporate Taxi Booking Mumbai"],
  ["Premium Corporate Cab Mumbai", "Reliable Corporate Cab Service Mumbai"],
  ["Best Corporate Taxi Service Mumbai", "Professional Cab Services Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Professional Corporate Cab Services",
    WhyChoosedescription: "Royal Route Cabs offers reliable corporate cab services in Mumbai for employee transportation, client visits, and business travel."
  },
  {
    WhyChooseheading: "Experienced & Trained Drivers",
    WhyChoosedescription: "Our drivers are well-trained, punctual, and experienced in handling corporate travel requirements across Mumbai."
  },
  {
    WhyChooseheading: "Flexible Corporate Travel Solutions",
    WhyChoosedescription: "We provide customized cab solutions including daily office pickup-drop, hourly rentals, and event-based corporate transport."
  },
  {
    WhyChooseheading: "Transparent Billing & Pricing",
    WhyChoosedescription: "Royal Route Cabs offers clear pricing and corporate billing with no hidden charges, ensuring easy expense management."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our corporate cab services in Mumbai operate round the clock to support all business travel needs including night shifts."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "All vehicles are regularly serviced, sanitized, and maintained to ensure comfort and safety for employees and clients."
  },
  {
    WhyChooseheading: "Wide Range of Fleet Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for corporate groups."
  },
  {
    WhyChooseheading: "Trusted Corporate Travel Partner",
    WhyChoosedescription: "Royal Route Cabs is trusted by businesses in Mumbai for reliable, punctual, and professional corporate cab services."
  }
]

};

const faqData = [
  { question: "Do you provide corporate cab services in Mumbai?", answer: "Yes, Royal Route Cabs offers corporate cab services for companies across Mumbai." },
  { question: "What types of corporate services do you provide?", answer: "We provide employee transport, airport transfers, client visits, and event-based travel solutions." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our corporate cab service operates 24/7 including night shifts." },
  { question: "Do you provide monthly packages?", answer: "Yes, we offer flexible monthly and long-term corporate packages." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Is pricing transparent?", answer: "Yes, we provide clear billing with no hidden charges." },
  { question: "Do you provide airport pickup for corporate clients?", answer: "Yes, we offer airport transfers for employees and business guests." },
  { question: "Are drivers professional?", answer: "Yes, all drivers are trained, verified, and experienced for corporate travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup and drop from office, home, and airport locations." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal Shah",
    feedback:
      "We use Royal Route Cabs for our corporate travel in Mumbai. Very reliable and professional service.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Mehta",
    feedback:
      "Excellent corporate cab service. On-time pickups and clean vehicles for our employees.",
    rating: 5
  }
];
















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Mumbai",
  "image": "https://www.royalroutecabs.com/assets/images/corporate-cab-services-mumbai.jpg", // replace if needed
  "description": "Book corporate cab services in Mumbai with Royal Route Cabs for reliable employee transportation, office travel, and business commuting. Monthly cab packages available with sedan, SUV, Innova, and executive cars. 24x7 professional service.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15000", // monthly corporate package starting price (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/corporate-cab-services-mumbai"
  }
};




  return (
    <div>
<Helmet>
  <title>Corporate Cab Services in Mumbai | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book corporate cab services in Mumbai with Royal Route Cabs. Employee transport, office cab service, and monthly corporate taxi solutions with safe and professional drivers."
  />

  <meta
    name="keywords"
    content="corporate cab services mumbai, corporate taxi service mumbai, business cab service mumbai, employee transportation mumbai, office cab service mumbai, company cab rental mumbai, corporate car rental mumbai, monthly cab service mumbai, corporate travel cab mumbai, staff pickup drop cab mumbai, executive cab service mumbai, corporate taxi booking mumbai, premium corporate cab mumbai, reliable corporate cab service mumbai, best corporate taxi service mumbai, professional cab services mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/31.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinmumbai;